<template>
  <div>
    <div style="display:flex">
      <div style="display:flex;">
        <a-select style="width:110px;margin-top:auto;margin-bottom:auto" v-model="controlType" slot="addonAfter"
          default-value="default">
          <a-select-option value="default">
            <div style="font-size:12px">Bulk actions</div>
          </a-select-option>
          <a-select-option value="delete">
            <div style="font-size:12px">Delete</div>
          </a-select-option>
        </a-select>
        <a-button style="margin-left:2px" slot="enterButton" @click="onApply" type="primary" ghost>
          Apply
        </a-button>
      </div>

    </div>
    <a-table :columns="columns" :data-source="offercodelist" :pagination="pagination" :row-selection="rowSelection"
      @change="handleTableChange">
      
      <span slot="createdDate" slot-scope="text, record">
        <div>{{ record.createdDate != undefined ?
          moment(Date.parse(record.createdDate)).utc(1412144245453).format('YYYY-MM-DD HH:mm'): ''}}</div>
      </span>

      <span slot="action" slot-scope="text, record">
        <export-excel class="btn-cell-icon" :data="getJsonData(record)" :fields="json_fields" :meta="json_meta"
          type="xls" worksheet="Offer Code" name="Offer Code Data.xls">

          <a-icon style="margin-left:5px;color:#003300" type="download" />
        </export-excel>
        <a-divider type="vertical" />
        <a @click="DeleteOfferCodeOne(record._id)">Delete</a>
        <a-divider type="vertical" />
        <a @click="EditOfferCode(record._id)">Edit</a>
      </span>
    </a-table>
    <div style="display:flex;position:absolute;bottom: 10px;z-index: 1;">
      <a-select style="width:170px;margin-top:auto;margin-bottom:auto;margin-left:2px" v-model="filterCount"
        slot="addonAfter" default-value=0>
        <a-select-option v-for="item in filterList" :key="item.name" :value="item.id">
          <div style="font-size:12px">{{ item.name }}</div>
        </a-select-option>
      </a-select>
      <a-button style="margin-left:2px" slot="enterButton" @click="onFilterCount" type="primary" ghost>
        Filter Count
      </a-button>
    </div>
  </div>
</template>
<script>

import { api } from '../../helpers/Helpers';
var moment = require('moment-timezone');

var selecetedList = [];

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    selecetedList = selectedRows;
  },
};

const filterList = [
  {
    id: 10,
    name: '10 count'
  },
  {
    id: 25,
    name: '25 count'
  },
  {
    id: 50,
    name: '50 count'
  },
];

export default {
  data() {
    return {
      controlType: 'default',
      rowSelection,
      selecetedList,

      filterCount: 10,
      filterList,
      pagination: {
        onChange: page => {
        },
        pageSize: 10,
      },

      json_fields: {
        'Offer Code Name': 'Offer Code Name',
        'Offer Code Value': 'Offer Code Value',
        'Description': 'Description',
        'Creator': 'Creator'
      },
      json_data: [
        {
          'Offer Code Name': '',
          'Offer Code Value': '',
          'Description': '',
          'Creator': ''
        }
      ],
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      roomCellWidth: 'calc(900px + 50%)',
    };
  },
  props: [
    'offercodelist',
    'columns',
    'tableCellCount'
  ],
  components: {
  },

  created: function () {
    this.pagination.pageSize = this.tableCellCount;
    this.filterCount = this.tableCellCount;
  },

  methods: {
    moment,
    onApply() {
      if (this.controlType == 'default') {
        return;
      }
      else if (this.controlType == 'delete') {
        this.deleteOfferCode();
      }
    },
    deleteOfferCode: async function () {
      if (selecetedList.length <= 0)
        return;

      this.$confirm({
        title: 'Do you want to delete these offer codes?',
        // content: h => <div style="color:red;">Some descriptions</div>,
        onOk: () => {
          this.DeleteOfferCodeResult()
        },
        onCancel() {

        },
        class: 'test',
      });
    },

    DeleteOfferCodeResult: async function () {

      for (let i = 0; i < selecetedList.length; i++) {
        const res = await api.removeOfferCode(selecetedList[i]._id);
      }
      this.$emit('listUpdate');
    },

    getJsonData(record) {
      var json_data = [
        {
          'Offer Code Name': record.name,
          'Offer Code Value': record.value,
          'Description': record.description,
          'Creator': record.creatorName
        }
      ];
      return json_data;
    },

    DeleteOfferCodeOne: function (_id) {
      this.$confirm({
        title: 'Do you want to delete this offer code?',
        onOk: () => {
          this.DeleteOffercodeOneResult(_id);
        },
        onCancel() {
        },
        class: 'test',
      });
    },
    DeleteOffercodeOneResult: async function (_id) {
      const res = await api.removeOfferCode(_id);
      this.$emit('listUpdate');
    },

    EditOfferCode: async function (_id) {
      this.$router.push({ path: 'editoffercode', query: { id: _id } })
    },

    onFilterCount() {
      this.$emit('listFilterCount', this.filterCount);
    },

    handleTableChange(pagination, filters, sorter) {
      this.offerCodeListOrder(sorter.field, sorter.order);
    },
    offerCodeListOrder(_field, _order) {
      // this.$emit('listOrder', _field, _order);
      // // console.log("sorter.order--",_field,_order);
      // if (_order == "ascend") {
      //   this.offercodelist.sort(function (a, b) { return (a[_field] > b[_field]) ? 1 : ((b[_field] > a[_field]) ? -1 : 0); });
      // }
      // else if (_order == "descend") {
      //   this.offercodelist.sort(function (a, b) { return (a[_field] < b[_field]) ? 1 : ((b[_field] < a[_field]) ? -1 : 0); });
      // }
      // else if (_field != undefined) {
      //   this.offercodelist.sort(function (a, b) { return (a['name'] > b['name']) ? 1 : ((b['name'] > a['name']) ? -1 : 0); });
      // }
    }
  }
};
</script>